import React from "react";
import { Linkedin } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { LINKEDIN_URL, NAV_LINKS, scrollToId, ICON_LOGO } from "./shared";

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const onHome = location.pathname === "/";

  const go = (l) => {
    if (l.route) return navigate(l.route);
    if (!onHome) navigate("/", { state: { scrollTo: l.id } });
    else scrollToId(l.id);
  };

  return (
    <footer data-testid="site-footer" className="relative pt-16 pb-8" style={{ backgroundColor: "#1F1A38" }}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 pb-12" style={{ borderBottom: "1px solid rgba(216,216,216,0.15)" }}>
          <div>
            <img
              src={ICON_LOGO}
              alt="Fortim Ventures"
              className="h-16 sm:h-20 w-auto"
            />
            <p className="mt-4 max-w-sm text-sm leading-relaxed" style={{ color: "#8C8C8C" }}>
              Creating, growing and partnering with businesses across
              Dadra &amp; Nagar Haveli and Daman &amp; Diu.
            </p>
          </div>

          <nav className="flex flex-wrap gap-x-6 gap-y-3">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`footer-link-${l.id}`}
                onClick={() => go(l)}
                className="text-sm transition-colors duration-300"
                style={{ color: "#D8D8D8" }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#F5821F")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#D8D8D8")}
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-6">
          <p className="text-xs" style={{ color: "#8C8C8C" }}>
            &copy; 2026 Fortim Ventures Private Limited. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a data-testid="footer-email" href="mailto:info@fortim.in" className="text-xs" style={{ color: "#D8D8D8" }}>
              info@fortim.in
            </a>
            <a
              data-testid="footer-linkedin"
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="w-10 h-10 flex items-center justify-center rounded-full transition-colors duration-300"
              style={{ border: "1px solid rgba(216,216,216,0.25)", color: "#FAF9F7" }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#3B2C82"; e.currentTarget.style.borderColor = "#3B2C82"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; e.currentTarget.style.borderColor = "rgba(216,216,216,0.25)"; }}
            >
              <Linkedin size={16} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
